// @flow

import { Link } from "gatsby";
import React from "react";

import FooterSection from "@/components/FooterSection/FooterSection";

export type SectionLink = {
    content: string,
    path: string | (() => void),
};

type Props = {
    heading: {
        path?: string,
        content: string,
    },
    links: SectionLink[],
};

export const FooterLink = ({link}: { link: SectionLink }): React$Element<any> | React$Element<"a"> | React$Element<React$FragmentType> => {
    const { path, content } = link;
    if (typeof path === "function") {
        return (
            <a
                onClick={(e: MouseEvent) => {
                    e.preventDefault();
                    path();
                }}
                title={content}
                href={"#"}
            >
                {content}
            </a>
        );
    } else if (typeof path === "string") {
        /* Use Link from "gatsby" so linked pages can be preloaded */
        return (
            <Link to={path} activeClassName="link-active" title={content}>
                {content}
            </Link>
        );
    }

    return <></>;
};


const FooterLinksSection = (props: Props): React$Element<typeof FooterSection> => {
    const links = props.links.map((link, index) => (
        <li key={index} className={"line-height-xs"}>
            <FooterLink link={link} />
        </li>
    ));

    return (
        <FooterSection heading={props.heading}>
            <ol className={"mb-0"}>{links}</ol>
        </FooterSection>
    );
};

export default FooterLinksSection;
